import React from 'react';
import { Facebook, MapPin, MessageCircle, Clock } from 'lucide-react';
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-87">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.55a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.02z" data-id="element-88" />
  </svg>;
interface FooterProps {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
}
export function Footer({
  onOpenPrivacy,
  onOpenTerms
}: FooterProps) {
  return <footer className="bg-mystic-black border-t border-mystic-gold/10 pt-16 pb-8 px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-89">
      <div className="max-w-7xl mx-auto" data-id="element-90">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-91">
          {/* Brand & Info */}
          <div className="lg:col-span-2" data-id="element-92">
            <h3 className="text-2xl font-serif font-bold text-mystic-gold mb-4" data-id="element-93">
              Maestro Navy
            </h3>
            <p className="text-mystic-white/70 font-light max-w-md leading-relaxed mb-6" data-id="element-94">
              Guía espiritual y terapeuta energético dedicado a brindar
              claridad, equilibrio y bienestar a través de métodos profesionales
              y confidenciales.
            </p>
            <div className="flex gap-4" data-id="element-95">
              <a href="https://www.tiktok.com/@chatito3283" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-10 h-10 rounded-full bg-mystic-blue-900/50 border border-mystic-gold/20 flex items-center justify-center text-mystic-white hover:text-mystic-gold hover:border-mystic-gold/50 transition-colors" data-id="element-96">
                <TikTokIcon className="w-5 h-5" data-id="element-97" />
              </a>
              <a href="https://www.facebook.com/share/1CoHhkuXPW/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-mystic-blue-900/50 border border-mystic-gold/20 flex items-center justify-center text-mystic-white hover:text-mystic-gold hover:border-mystic-gold/50 transition-colors" data-id="element-98">
                <Facebook className="w-5 h-5" data-id="element-99" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-100">
            <h4 className="text-lg font-serif font-semibold text-mystic-white mb-4" data-id="element-101">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-102">
              <li className="flex items-start gap-3 text-mystic-white/70" data-id="element-103">
                <MapPin className="w-5 h-5 text-mystic-gold shrink-0 mt-0.5" data-id="element-104" />
                <span className="font-light" data-id="element-105">
                  Atención presencial en
                  <br data-id="element-106" />
                  Antofagasta, Chile
                </span>
              </li>
              <li className="flex items-center gap-3 text-mystic-white/70" data-id="element-107">
                <MessageCircle className="w-5 h-5 text-mystic-gold shrink-0" data-id="element-108" />
                <a href="https://wa.link/lvbw8v" target="_blank" rel="noopener noreferrer" className="font-light hover:text-mystic-gold transition-colors" data-id="element-109">
                  Escríbeme por WhatsApp
                </a>
              </li>
            </ul>
          </div>

          {/* Schedule */}
          <div data-id="element-110">
            <h4 className="text-lg font-serif font-semibold text-mystic-white mb-4" data-id="element-111">
              Horario
            </h4>
            <ul className="space-y-4" data-id="element-112">
              <li className="flex items-start gap-3 text-mystic-white/70" data-id="element-113">
                <Clock className="w-5 h-5 text-mystic-gold shrink-0 mt-0.5" data-id="element-114" />
                <span className="font-light" data-id="element-115">
                  Lunes a Sábado
                  <br data-id="element-116" />
                  10:00 - 20:00 hrs
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal & Copyright */}
        <div className="pt-8 border-t border-mystic-gold/10 text-center" data-id="element-117">
          <p className="text-xs text-mystic-white/40 font-light max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-118">
            Los servicios ofrecidos corresponden a orientación espiritual y
            bienestar personal. No sustituyen diagnósticos médicos, psicológicos
            ni asesorías legales.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-4" data-id="element-119">
            <button onClick={onOpenPrivacy} className="text-xs text-mystic-white/60 hover:text-mystic-gold transition-colors underline-offset-4 hover:underline" data-id="element-120">
              Política de Privacidad
            </button>
            <span className="text-mystic-gold/30 text-xs hidden sm:inline" data-id="element-121">
              •
            </span>
            <button onClick={onOpenTerms} className="text-xs text-mystic-white/60 hover:text-mystic-gold transition-colors underline-offset-4 hover:underline" data-id="element-122">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-xs text-mystic-white/30" data-id="element-123">
            &copy; {new Date().getFullYear()} Maestro Navy. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}